import Login from '../Pages/LoginPage';
import Home from '../Pages/HomePage';
import Account from '../Pages/AccountPage';

const routes = [
  {
    path: '/',
    lable: 'home',
    menu: 'home',
    exact: true,
    main: (props) => <Home {...props} />,
  },
  {
    path: '/login',
    lable: 'login',
    menu: 'login',
    exact: true,
    main: (props) => <Login {...props} />,
  },
  {
    path: '/accounts',
    lable: 'accounts',
    menu: 'accounts',
    exact: true,
    main: (props) => <Account {...props} />,
  },
];

export default routes;
